import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.NOTIFICATIONS;

export const NOTIFICATIONS = createActionName(reducerName, 'NOTIFICATIONS');
